<template>
  <div>
    <el-card :body-style="bodyStyle" shadow="never" class="list-view">
      <el-row :gutter="20">
        <el-col
          :xs="12"
          :sm="12"
          :lg="6"
          :md="6"
          :class="[
            isFilterVisible
              ? 'thumbnail__dimension'
              : 'thumbnail__dimension--non-filter',
          ]"
        >
          <div
            class="thumbnail-image"
            v-bind:style="{ backgroundImage: 'url(' + thumbnail + ')' }"
          ></div>
        </el-col>
        <router-link v-if="provider.slug" :to="providerView">
          <el-col :xs="12" :sm="12" :md="4" class="text-left">
            <div class="subtitle1 text-left mt-20">
              {{ providerName }}
            </div>
            <div v-if="isMobileLayout" class="provider-text subtitle2 subtitle2--light text-left">
              {{ origin }}
            </div>
          </el-col>
          <el-col v-if="!isMobileLayout" :xs="24" :sm="24" :md="4" class="text-left">
            <div class="subtitle2 subtitle2--light text-left mt-20">
              {{ origin }}
            </div>
          </el-col>
        </router-link>
        <el-col :xs="24" :sm="24" :md="14">
          <el-collapse v-model="activeNames" @change="collapseChange" class="mt-10">
            <el-collapse-item
              class="procuder-list-product-title"
              :title="$i18n.t('providers.providerView.label.producerProduct')"
            >
            <div v-if="!productLoader && provider.productList">
              <div
                v-for="(product, ind) in provider.productList"
                :key="ind"
                class="text-left"
              >
              <a href="#" @click="productView(product)">
                {{ product.name }}
              </a>
              </div>
            </div>
            <div v-if="productLoader">
              <div class="boires-page-loader"></div>
            </div>
            </el-collapse-item>
          </el-collapse>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24">
          <!-- <el-divider class="m-0 mt-6 mb-6" /> -->
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { get, head } from "@/utils/lodash";
import layoutUtils from "@/utils/layout-utils";
import { mapActions } from "vuex";
import { getDefaultAvailability } from "@/utils/market-utils";

import imgProviderDefault from "@/assets/images/provider/provider-default.png";

export default {
  props: {
    provider: {
      type: Object,
      default: () => {},
    },
    isFilterVisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activeNames: "",
      productLoader: false,
    };
  },
  computed: {
    images() {
      return {
        providerDefault: {
          src: imgProviderDefault,
        },
      };
    },
    providerView() {
      return {
        name: "provider",
        params: {
          slug: get(this.provider, "slug", ""),
        },
      };
    },
    providerName() {
      return get(this.provider, "name");
    },
    origin() {
      const originHead = head(this.provider.origins);
      const country = get(originHead, "country.name");
      const region = get(originHead, "region.name", "");
      return originHead && `${country}, ${region == null ? "" : region}`;
    },
    thumbnail() {
      const thumbnail = get(this.provider, "mainImage.thumbnailLink");

      if (thumbnail == null) {
        return this.images.providerDefault.src;
      }

      return thumbnail;
    },
    bodyStyle() {
      if (!layoutUtils.isMobileLayout(this.$mq) && !this.isFilterVisible) {
        return {
          padding: "0 0 0 20px",
        };
      }
      return {
        padding: "0px",
      };
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
  },
  methods: {
    ...mapActions("product", ["fetchProducerProduct"]),
    productView(product) {
      let resultPuid = null;
      let countryCode = this.$route.query.type ? this.$route.query.type : 'QC';
      const order = countryCode == 'QC' ? ['IP', 'SAQ', 'Brouhh', 'MERCH_MTL', 'BERGEVILLE'] : ['PI', 'LCBO', 'MERCH_TORONTO'];
      for (let code of order) {
          for (let prod of product.productInventories) {
            if (prod.inventory && prod.inventory.code === code) {
              resultPuid = prod.puid;
              break;
            }
          }
          if (resultPuid) {
            break;
          }
        }
        this.$router.push({
          name: "product",
        params: {
            slug: product.slug,
            productType: this.productType,
            backBtnName: this.backBtnName,
        },
        query: {
            id: resultPuid,
            productType: product.puid && this.productType != ""
                ? this.productType 
                : undefined,
            pid: product.id
        },
        })
    },
    collapseChange(event) {
      if(event.length > 1) {
        if(!this.provider.productList){
          this.getProducts(this.provider.id)
        }
      }
    },
    getProducts(providerId){
      const market = localStorage.getItem("countryCode") || "QC";
      let filters =  {
        page: 1,
        size :51,
        availability: getDefaultAvailability(market),
        providerId
      }
      this.productLoader = true;
      this.fetchProducerProduct({ filters })
      .then(() => {
        this.productLoader = false;
        // this.stopLoading();
      })
      .catch(() => {
        this.productLoader = false;
        // this.stopLoading();
      });
    },
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/variables.scss";

a {
  text-decoration: none;
  color: inherit;
}
.boires-page-loader{
  width: 25px;
    height: 25px;
    border-width: 5px;

}
.el-card {
  border-radius: 0;
  border: 0;
  text-align: center;
}
.provider__origin {
  color: $color-on-background-area1 !important;
}
.subtitle2--light {
  color: $color-on-background-area1;
}
.subtitle2 {
  @media screen and (max-width: $media-lg) {
    white-space: nowrap;
  }
}
.provider-content {
  height: 60px;
}
.thumbnail-image {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>
